import type TableView from "../store/schema/TableView";
import getResolvedSelectedRowKeys from "./getResolvedSelectedRowKeys";

export interface SelectionCounts {
    /** Number of literal rows the user picked individually. */
    items: number;
    /** Number of collapsed group headers the user added to the selection. */
    groups: number;
    /** Total rowKey count after resolving selected group headers to their rows. */
    resolved: number;
}

/**
 * Returns counts describing the current selection in a TableView.
 *
 * `items` reflects only literal selected rows (does NOT include rows hidden
 * inside selected collapsed groups). `groups` reflects how many collapsed
 * group headers are part of the selection. `resolved` reflects the total
 * number of rowKeys that would actually be acted upon — equal to
 * `items + sum(rows per selected header)` because the selection mutators
 * keep the literal and group-header sets disjoint.
 *
 * @param tableView the table view
 */
export default function getSelectionCounts(tableView: TableView): SelectionCounts {
    return {
        items: tableView.selectedRowKeys.size,
        groups: tableView.selectedGroupHeaders.size,
        resolved: getResolvedSelectedRowKeys(tableView).length,
    };
}
